export enum Role {
  // noinspection JSUnusedGlobalSymbols
  Gast = 0,
  Organisator = 1,
  Ceremoniemeester = 2,
  Admin = 3
}
